import { useLingui } from '@lingui/react';
import styled from 'styled-components';
import { WrapperItem } from '~/components/ui/wrapper-item';
import Modal from '~/components/ui/modal';
import { useEffect, useState } from 'react';
import { classic } from '~/themes';
import Button from '~/components/ui/button';
import { RulesSoloContent } from '~/components/game/rules-solo-content';
import { RulesBattleContent } from '~/components/game/rules-battle-content';
import { RulesClassementContent } from '~/components/game/rules-classement-content';

interface IProps {
  open: boolean;
  onClose: () => void;
  modeDefault?: 'solo' | 'battle' | 'rancking';
}
type TProps = IProps;

export default function RulesDialog({ open, onClose, modeDefault }: TProps) {
  const { i18n } = useLingui();
  const [mode, setMode] = useState<'solo' | 'battle' | 'rancking'>('solo');

  useEffect(() => {
    if (modeDefault) setMode(modeDefault);
  }, [modeDefault]);

  return (
    <Modal
      heightPortrait="90%"
      heightLandscape="75%"
      widthPortrait="95%"
      widthLandscape="60%"
      allowHeightMax
      onClose={onClose}
      open={open}
    >
      <Container>
        <WrapperItem
          setMaxHeight
          widthPortrait="100%"
          widthLandscape="100%"
          title={`${i18n._('common.rules')}`}
        >
          <ContentWrapper>
            <SDivMode>
              <SBtnMode
                $selected={mode === 'solo'}
                onClick={() => setMode('solo')}
              >
                <SSpanTextLg $marginBottom="0" $selected={mode === 'solo'}>
                  {i18n._('mode.solo')}
                </SSpanTextLg>
              </SBtnMode>
              <SBtnMode
                $selected={mode === 'rancking'}
                onClick={() => setMode('rancking')}
              >
                <SSpanTextLg $marginBottom="0" $selected={mode === 'rancking'}>
                  {i18n._('common.leaderBoard')}
                </SSpanTextLg>
              </SBtnMode>
              <SBtnMode
                $selected={mode === 'battle'}
                onClick={() => setMode('battle')}
              >
                <SSpanTextLg $marginBottom="0" $selected={mode === 'battle'}>
                  {i18n._('mode.battle')}
                </SSpanTextLg>
              </SBtnMode>
            </SDivMode>
            {mode === 'solo' && <RulesSoloContent />}
            {mode === 'battle' && <RulesBattleContent />}
            {mode === 'rancking' && <RulesClassementContent />}
            <SDivBtn className={open ? 'open' : 'closed'}>
              {open && (
                <Button
                  disabled={!open}
                  color="primary"
                  onClick={onClose}
                  margin="0"
                >
                  {i18n._('common.ok')}
                </Button>
              )}
            </SDivBtn>
          </ContentWrapper>
        </WrapperItem>
      </Container>
    </Modal>
  );
}

const ContentWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
  width: 100%;
`;

const SDivBtn = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: auto;
`;

const Container = styled.div`
  padding: 5px;
  height: 100%;
  display: flex;
  justify-content: center;
  width: 100%;
`;

const SDivMode = styled.div`
  align-items: center;
  border-radius: 16px 16px 0px 0px;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  min-height: 50px;
  width: 100%;
`;
const SBtnMode = styled.div<{ $selected: boolean }>`
  flex: 0 0 33.33%;
  background-color: ${({ $selected }) => ($selected ? '#53D2D7' : '#fff')};
  align-items: center;
  display: flex;
  justify-content: center;
  height: 100%;
  padding: 10px;
`;

const SSpanTextLg = styled.h2<{ $selected: boolean; $marginBottom?: string }>`
  color: ${({ $selected }) =>
    $selected ? `${classic.token?.colorWhite}` : `#00000080`};
  font-family: 'Riffic Free', sans-serif;
  font-weight: 700;
  font-size: 1.3rem;
  text-align: center;
  user-select: none;

  @media screen and (max-height: 450px) {
    margin-bottom: ${({ $marginBottom }) =>
      $marginBottom ? $marginBottom : '10px'};
    font-size: 1rem;
  }
  @media screen and (max-width: 450px) {
    font-size: 1rem;
  }
`;
